import $ from 'jquery';
import CustomEvent from 'custom-event';
import {arrayToProperties} from './helpers';

/**
 * @param {HTMLElement} element
 * @param {Object} opts
 */
export function wishlistShareForm(element, opts = {}) {
  const defaults = {
    form: '[data-share-form]',
    button: '[data-share-submit]',
    timeout: 2000,
    buttonSuccessText: 'Sent',
    buttonErrorText: 'Error',
    buttonSendingText: 'Sending',
    successMessage: 'You have successfully shared your wishlist',
    errorMessage: 'You have successfully shared your wishlist',
  };

  if (!element) {
    return null;
  }

  const options = {
    ...defaults,
    ...opts,
    ...element.dataset,
  };
  const $form = $(element).find(options.form);
  const form = $form.get(0);
  const $button = $form.find(options.button);
  const buttonText = $button.text();

  bindEventListeners();

  function bindEventListeners() {
    $form.on('submit.wishlist', handleFormSubmit);
  }

  function removeEventListeners() {
    $form.off('submit.wishlist');
  }

  /**
   * @param {Event} event
   */
  function handleFormSubmit(event) {
    event.preventDefault();

    sendEmail();
  }

  function sendEmail() {
    const formData = $form.serializeArray();
    const {emailId, fromEmailId, note} = arrayToProperties(formData);
    const params = {
      toEmailId: emailId,
      fromName: fromEmailId,
      note
    }

    setInterimButton(options.buttonSendingText);

    console.log(window._swat);
    window._swat.sendListViaEmail(params, handleSuccess, handleError)
  }

  function handleSuccess() {
    setInterimButton(options.buttonSuccessText);
    window.setTimeout(restoreForm, options.timeout);
  }

  function handleError() {
    setInterimButton(options.buttonErrorText);
    window.setTimeout(restoreForm(true), options.timeout);
  }

  function restoreForm(isError=false) {
    restoreButton();
    dispatchCartEvent();
    dispatchAlertEvent(isError);
    clearForm();
  }

  function dispatchCartEvent(isError) {
    const cartEvent = new CustomEvent('message', {
      bubbles: true,
      detail: {
        messages: [
          {
            type: isError ? 'error' : 'success',
            text: isError ? options.errorMessage : options.successMessage,
          },
        ],
      },
    });

    form.dispatchEvent(cartEvent);
  }

  function dispatchAlertEvent() {
    const alertEvent = new CustomEvent('alert:close', {
      bubbles: true,
    });

    form.dispatchEvent(alertEvent);
  }

  function clearForm() {
    $form.get(0).reset();
  }

  function restoreButton() {
    $button.text(buttonText);
    $button.attr('disabled', false);
  }

  function setInterimButton(text) {
    $button.text(text);
    $button.attr('disabled', true);
  }

  function destroy() {
    removeEventListeners();
  }

  return {
    destroy,
  };
}
